export default __webpack_public_path__ + "cloud.f859b75b.svg";